module.exports = __webpack_public_path__ + "img/def_avatar.cfa71b21.jpg";